var _ = {
  linear: [
    0,
    0,
    1,
    1
  ],
  easeIn: [
    0.3333333333333333,
    0,
    0.6666666666666666,
    0
  ],
  easeOut: [
    0.22,
    1,
    0.36,
    1
  ],
  easeInOut: [
    0.4,
    0,
    0.2,
    1
  ],
  snap: [
    0.05,
    0.7,
    0.1,
    1
  ],
  back: [
    0.3333333333333333,
    1.4166666666666667,
    0.6666666666666666,
    1
  ],
  anticipate: [
    0.35,
    -0.25,
    0.15,
    1
  ]
}, f = Object.fromEntries([["linear", (e) => e <= 0 ? 0 : e >= 1 ? 1 : e], ...Object.entries(_).filter(([e]) => e !== "linear").map(([e, [t, n, r, i]]) => [e, O(`cubic-bezier(${t}, ${n}, ${r}, ${i})`)])]), b = /* @__PURE__ */ new Map();
function p(e) {
  const t = /^cubic-bezier\(\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*\)$/.exec(e);
  if (!t) return null;
  const n = parseFloat(t[1]), r = parseFloat(t[2]), i = parseFloat(t[3]), o = parseFloat(t[4]);
  return [
    n,
    r,
    i,
    o
  ].some(Number.isNaN) || n < 0 || n > 1 || i < 0 || i > 1 ? null : [
    n,
    r,
    i,
    o
  ];
}
function C(e) {
  if (e) {
    const n = _[e];
    if (n) return [
      n[0],
      n[1],
      n[2],
      n[3]
    ];
    if (e.startsWith("cubic-bezier(")) {
      const r = p(e);
      if (r) return r;
    }
  }
  const t = _.easeInOut;
  return [
    t[0],
    t[1],
    t[2],
    t[3]
  ];
}
function O(e) {
  const t = p(e);
  if (!t) return null;
  const [n, r, i, o] = t, c = (s, u, l) => 3 * (1 - s) * (1 - s) * s * u + 3 * (1 - s) * s * s * l + s * s * s;
  return (s) => {
    if (s <= 0) return 0;
    if (s >= 1) return 1;
    let u = 0, l = 1;
    for (let d = 0; d < 24; d++) {
      const h = (u + l) / 2;
      c(h, n, i) < s ? u = h : l = h;
    }
    return c((u + l) / 2, r, o);
  };
}
function I(e) {
  if (!e) return f.easeInOut;
  const t = f[e];
  if (t) return t;
  if (e.startsWith("cubic-bezier(")) {
    let n = b.get(e);
    return n || (n = O(e) ?? f.easeInOut, b.set(e, n)), n;
  }
  return f.easeInOut;
}
function m(e) {
  if (!e.startsWith("#")) return null;
  const t = e.slice(1);
  if (t.length !== 6 && t.length !== 8) return null;
  const n = parseInt(t.slice(0, 2), 16), r = parseInt(t.slice(2, 4), 16), i = parseInt(t.slice(4, 6), 16);
  return isNaN(n) || isNaN(r) || isNaN(i) ? null : [
    n / 255,
    r / 255,
    i / 255
  ];
}
function y(e) {
  const t = (n) => Math.max(0, Math.min(255, Math.round(n * 255)));
  return `#${t(e[0]).toString(16).padStart(2, "0")}${t(e[1]).toString(16).padStart(2, "0")}${t(e[2]).toString(16).padStart(2, "0")}`.toUpperCase();
}
function w(e, t = [0, 1], n) {
  if (Number.isNaN(e)) return 1;
  const [r, i] = t, o = i - r;
  if (o === 0) return 1;
  const c = (e - r) / o, s = Math.max(0, Math.min(1, c));
  return I(n ?? "linear")(s);
}
function a(e, t, n) {
  return e + (t - e) * n;
}
function T(e, t, n) {
  if (typeof e == "number" && typeof t == "number") return a(e, t, n);
  if (typeof e == "string" && typeof t == "string") {
    const r = m(e), i = m(t);
    return r && i ? y([
      a(r[0], i[0], n),
      a(r[1], i[1], n),
      a(r[2], i[2], n)
    ]) : n < 0.5 ? e : t;
  }
  if (Array.isArray(e) && Array.isArray(t) && e.length === t.length) {
    if (e.length === 3) return [
      a(e[0], t[0], n),
      a(e[1], t[1], n),
      a(e[2], t[2], n)
    ];
    if (e.length === 4) {
      const r = e, i = t;
      return [
        a(r[0], i[0], n),
        a(r[1], i[1], n),
        a(r[2], i[2], n),
        a(r[3], i[3], n)
      ];
    }
  }
  return n < 0.5 ? e : t;
}
var v = /* @__PURE__ */ new WeakMap();
function g(e) {
  let t = v.get(e);
  return t || (t = new N(e), v.set(e, t)), t;
}
var N = class {
  _scene;
  _transitions = /* @__PURE__ */ new Map();
  _observer = null;
  _now = () => performance.now();
  _after = (e, t) => {
    const n = setTimeout(t, e);
    return () => clearTimeout(n);
  };
  _timers = /* @__PURE__ */ new Map();
  _timerCount = 0;
  constructor(e) {
    this._scene = e;
  }
  start(e, t, n, r) {
    this._transitions.set(e, {
      config: t,
      startTime: this._now() + (t.delay ?? 0) * 1e3,
      onUpdate: n,
      onComplete: r
    }), this._ensureObserver(), n(0);
  }
  cancel(e) {
    this._transitions.delete(e), this._removeObserverIfIdle();
  }
  cancelByPrefix(e) {
    for (const t of this._transitions.keys()) t.startsWith(e) && this._transitions.delete(t);
    this._removeObserverIfIdle();
  }
  cancelAll() {
    this._transitions.clear(), this._removeObserverIfIdle();
  }
  has(e) {
    return this._transitions.has(e);
  }
  get activeCount() {
    return this._transitions.size;
  }
  setClock(e) {
    this._now = e, this._after = (t, n) => {
      const r = this._timerCount++;
      return this._timers.set(r, {
        due: e() + t,
        fn: n
      }), this._ensureObserver(), () => {
        this._timers.delete(r);
      };
    };
  }
  after(e, t) {
    return this._after(e, t);
  }
  dispose() {
    this._timers.clear(), this.cancelAll();
  }
  _tick() {
    this._tickTransitions(), this._timers.size > 0 && this._fireDueTimers(), this._removeObserverIfIdle();
  }
  _tickTransitions() {
    if (this._transitions.size === 0) return;
    const e = this._now(), t = [];
    for (const [n, r] of this._transitions) {
      const i = e - r.startTime;
      if (i < 0) continue;
      const o = r.config.duration * 1e3, c = o > 0 ? Math.min(i / o, 1) : 1;
      if (c >= 1)
        r.onUpdate(1), t.push([n, r]);
      else {
        const s = I(r.config.easing);
        r.onUpdate(s(c));
      }
    }
    for (const [n, r] of t)
      this._transitions.get(n) === r && (this._transitions.delete(n), r.onComplete?.());
  }
  _fireDueTimers() {
    const e = this._now(), t = [...this._timers].filter(([, n]) => n.due <= e).sort((n, r) => n[1].due - r[1].due || n[0] - r[0]);
    for (const [n, r] of t)
      this._timers.delete(n) && r.fn();
  }
  _removeObserverIfIdle() {
    this._transitions.size === 0 && this._timers.size === 0 && this._removeObserver();
  }
  _ensureObserver() {
    this._observer || (this._observer = this._scene.onBeforeRenderObservable.add(() => {
      this._tick();
    }));
  }
  _removeObserver() {
    this._observer && (this._scene.onBeforeRenderObservable.remove(this._observer), this._observer = null);
  }
};
export {
  T as a,
  C as i,
  _ as n,
  w as r,
  g as t
};

//# sourceMappingURL=TransitionManager-BD_yHXIb.js.map